import { getTotalPages, getTotalHits } from '../../utils/pagination-config'
import {
  initialState,
  initialFilterState
} from './initial-state'

export default function search (state = initialState, action) {
  switch (action.type) {
    case 'SET_SEARCH_FILTER_VALUE':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.key]: action.value
        }
      }
    case 'SET_SEARCH_FILTER_VALUES':
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      }
    case 'SET_SEARCH_RESULTS':
      return {
        ...state,
        results: action.value['hits'],
        resultsTrueTotal: action.value['pagination']['total_hits'],
        pagination: {
          ...action.value['pagination'],
          total_hits: getTotalHits(action.value['pagination']['total_hits']),
          total_pages: getTotalPages(action.value['pagination']['total_pages'])
        }
      }
    case 'SET_ROW':
      return {
        ...state,
        modalRow: action.value.modalRow,
        modalRowIndex: action.value.modalRowIndex
      }
    case 'OPEN_MODAL':
      return {
        ...state,
        detailsModalOpen: action.value === 'diamondDetails',
        compareModalOpen: action.value === 'diamondCompare'
      }
    case 'CLOSE_MODAL':
      return {
        ...state,
        detailsModalOpen: false,
        compareModalOpen: false
      }
    case 'RESET_SEARCH':
      return {
        ...initialState,
        selectedItems: state.selectedItems || [],
        allSuppliers: state.allSuppliers
      }
    case 'TOGGLE_ADVANCED_PANEL':
      return {
        ...state,
        advancedShown: !state.advancedShown
      }
    case 'SET_PAGE':
      return {
        ...state,
        currentPage: action.value.selected
      }
    case 'SET_COMPARE_DATA':
      state.selectedItems = state.selectedItems || []
      const found = state.selectedItems.some(function (el) {
        return el['Diamond ID'] === action.value['Diamond ID']
      })
      if (found) {
        return {
          ...state,
          selectedItems: state.selectedItems.filter(function (el) {
            return el['Diamond ID'] !== action.value['Diamond ID']
          })
        }
      } else {
        return {
          ...state,
          selectedItems: [...state.selectedItems, action.value]
        }
      }
    case 'SWAP_COMPARE_DATA':
      const {pos1, pos2} = action.value
      const selectedItems = [...state.selectedItems]
      const item1 = selectedItems[pos1]
      const item2 = selectedItems[pos2]
      // sanity check to make sure that the compare items exist to swap
      if (typeof item1 === 'undefined' || item2 === 'undefined') {
        return {
          ...state
        }
      }
      const temp = item1
      selectedItems[pos1] = item2
      selectedItems[pos2] = temp
      return {
        ...state,
        selectedItems: [...selectedItems]
      }
    case 'REMOVE_ITEM':
      return {
        ...state,
        selectedItems: state.selectedItems.filter(function (el) {
          return el['Diamond ID'] !== action.value['Diamond ID']
        })
      }
    case 'CLEAR_COMPARE_DATA':
      return {
        ...state,
        selectedItems: []
      }
    case 'SET_SUPPLIER_LIST':
      return {
        ...state,
        allSuppliers: {
          data: action.value,
          fetchedAt: Date.now()
        }
      }
    case 'SET_FIND_A_DIAMOND_PARAMS':
      return {
        ...state,
        filters: Object.assign({}, initialFilterState, action.value)
      }
    case 'ADD_HIGHLIGHTED_DIAMOND_ROW':
      return {
        ...state,
        highlightedRows: state.highlightedRows.includes(action.value) ? state.highlightedRows : state.highlightedRows.concat(action.value)
      }
    case 'SET_HITS_PER_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          hits_per_page: action.value
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/diamond-search/index.js